module.exports = __webpack_public_path__ + "static/card-2-80eaae01093fcef930518cb735be78a3.jpg";